import { Show } from '@library/components'
import { KnownSuffixes, PagesUrls } from '@library/model'
import { messengerRef } from 'common/messenger'
import type { FC } from 'react'
import { lazy } from 'react'
import { Route, Routes } from 'react-router'

import { Layout, Main, Project } from '../pages'
import type { AppHeaderProps } from '../types'
import { Playground } from './Playground'
import { WillThrow } from './WillThrow'

/**
 * Своего фронта у картографии не будет,
 * пока не заедут workspace'ы
 * */

const CartographyFront = lazy(() => import('@utils/Cartography'))
const Modeling = lazy(() => import('@modeling/Modeling'))
const StratigraphyLayout = lazy(() => import('@stratigraphy/Layout'))
const StratigraphyMain = lazy(() => import('@stratigraphy/Main'))
const StratigraphyPlanchette = lazy(() => import('@stratigraphy/TiePlanchette'))
const StratigraphyModeling = lazy(() => import('@stratigraphy/TieModeling'))
const Interpretation = lazy(() => import('@window2d/Interpretation'))
const BulkImportHeader = lazy(() => import('@bulk/BulkImportHeader'))
const BulkImportMain = lazy(() => import('@bulk/BulkImport'))
const DataManager = lazy(() => import('@dataManager/DataManager'))
const CrossPlot = lazy(() => import('@utils/CrossPlot'))

export const AppRoutes: FC<AppHeaderProps> = ({ getToken, logout }) => {
  return (
    <Routes>
      <Route path="/" element={<Layout getToken={getToken} logout={logout} />}>
        <Route index={true} element={<Main />} />
      </Route>
      <Route path={`${PagesUrls.Project}/:projectId`}>
        <Route index={true} element={<Project getToken={getToken} />} />
        <Route path={KnownSuffixes.BulkImport} element={<BulkImportHeader />}>
          <Route index={true} element={<BulkImportMain />} />
        </Route>
      </Route>
      <Route path={PagesUrls.Stratigraphy} element={<StratigraphyLayout />}>
        <Route index={true} element={<StratigraphyMain />} />
        <Route path={KnownSuffixes.StratigraphyPlanchette} element={<StratigraphyPlanchette />} />
        <Route path={KnownSuffixes.StratigraphyModeling} element={<StratigraphyModeling />} />
      </Route>
      <Route
        path={PagesUrls.Cartography}
        element={<CartographyFront coreMessenger={messengerRef.current} />}>
        <Route index={true} element={<CartographyFront />} />
      </Route>
      <Route
        path={PagesUrls.Modeling}
        element={<Modeling coreMessenger={messengerRef.current} />}
      />
      <Route path={PagesUrls.Interpretation} element={<Interpretation />} />
      <Route path={PagesUrls.DataManager} element={<DataManager />} />
      <Route path={PagesUrls.CrossPlot} element={<CrossPlot />} />
      <Route
        path="/playground"
        element={
          <Show when={!PRODUCTION}>
            <Playground />
          </Show>
        }
      />
      <Route path="*" element={<WillThrow />} />
    </Routes>
  )
}
